export class MobileTabModel {
    Title: string;
    PropertyName: string;

    constructor(displayName?: string, propertyName?: string) {
        this.Title = displayName || '';
        this.PropertyName = propertyName || '';
    }
}
